// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"styles_pageHeader__1_6ka","subtitle":"styles_subtitle__2g_1X","infoLine":"styles_infoLine__2S_Pc","tab":"styles_tab__vEN50","comingSoon":"styles_comingSoon__1puGD"};